export class SalesInfoRequestDto {
    reportFormat:string;
    startDate: Date | null;
    endDate: Date | null;
}